<template>
  <div class="po-text-tab">
    <div class="row">
      <!-- PO Text Vertical (FORM02: po_text.cat_po_vertical) -- cuma tampilan, BE men-generate ulang tiap Save. -->
      <div v-if="isFieldVisibleFn('cat_po_vertical', PO_TEXT_TAB)" class="col-md-6">
        <div class="card h-100">
          <div class="card-header py-3" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">PO Text Vertical</h6>
          </div>
          <div class="card-body py-1 card-body-tab" style="padding-left: 1rem">
            <pre class="border p-2 bg-white po-text-block">{{ mcrItem.cat_po_vertical || '-' }}</pre>
          </div>
        </div>
      </div>
      <!-- MCR History (FORM02: po_text.mcr_history, display_only): baris dari eu_material_mcr / eu_service_mcr sesuai
           sumber data (hydrate_from). Tampilan saja. -->
      <div v-if="isTableVisible(PO_TEXT_TAB, MCR_HISTORY_FIELD)" class="col-md-6">
        <div class="card h-100">
          <div class="card-header py-3" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">MCR History</h6>
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="mcrHistory" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="400px"
              :row-class="() => 'cursor-pointer'" @row-click="openMcrHistory">
              <Column field="mcr_code" header="MCR Number" header-class="bg-light text-center" />
              <Column field="subject" header="Description" header-class="bg-light text-center" />
              <template #empty>
                <div class="text-center text-muted py-3">No MCR history found.</div>
              </template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { cataloguerTabMixin, useCataloguerTabEngine, createTabDialog } from "./New_CataloguerTab";

// Key tab di FORM02_BASE.json
const PO_TEXT_TAB = "po_text";
const MCR_HISTORY_FIELD = "mcr_history";

// Props, setup engine, dialog, bind ke mcrItem: kerangka bersama New_CataloguerTab.js.
export default {
  name: "PoTextTab",
  mixins: [cataloguerTabMixin],
  setup(props) {
    return useCataloguerTabEngine(props);
  },
  data() {
    return {
      PO_TEXT_TAB,
      MCR_HISTORY_FIELD,
      dialog: createTabDialog(this.mcrItem)
    };
  },
  computed: {
    ...mapState({
      mcrHeader: (state) => state.mcr.mcrHeader
    }),
    // Riwayat MCR (sudah di-hydrate dari sumber yang sesuai lewat config), tanpa MCR yang sedang dibuka.
    mcrHistory() {
      const list = this.mcrItem?.[MCR_HISTORY_FIELD] || [];
      const ownMcrNumber = this.mcrHeader?.mcr_number;
      if (!ownMcrNumber) return list;
      return list.filter((row) => (row.emcr?.mcr_number || row.mcr_code) !== ownMcrNumber);
    }
  },
  methods: {
    // row.emcr = header MCR terkait (id + mcr_code internal), dibuka di tab baru (route Material Request, lihat saja).
    openMcrHistory(event) {
      const emcr = event.data?.emcr;
      if (!emcr?.id || !emcr?.mcr_code) return;
      const route = this.$router.resolve({
        name: "MCR Form for Material Request",
        params: {
          moduleSlug: this.$route.params.moduleSlug || "material-management",
          id: emcr.id,
          action: "edit",
          mcrCode: emcr.mcr_code
        }
      });
      window.open(route.href, "_blank");
    }
  }
};
</script>

<style scoped>
.po-text-block {
  min-height: 400px;
  font-size: 13px;
  border-radius: 6px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
